module.exports = __webpack_public_path__ + "media/images/pro/2-e5edb5b6ef85866ea6448ae2c3b857c8.png";